var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "call-192_svgrepo.com",
    clipPath: "url(#clip0_988_339)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "call-[#192]",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.4786 25.1258C27.5834 27.846 24.0764 29.2027 21.5708 28.9765C18.1488 28.6671 14.4252 26.8521 11.5986 24.853C7.44391 21.9144 3.5521 17.3687 1.2843 12.545C-0.318429 9.13654 -0.678024 4.94585 1.70578 1.83899C2.58738 0.690586 3.54051 0.0772508 4.97311 0.00571751C6.96057 -0.0909492 7.23898 1.04605 7.92144 2.81698C8.42991 4.14131 9.10851 5.49223 9.48744 6.8649C10.197 9.42656 7.71651 9.53363 7.40331 11.6274C7.20804 12.9479 8.80884 14.7187 9.53191 15.6602C10.949 17.5046 12.6523 19.0955 14.574 20.3057C15.6741 20.9998 17.4508 22.2505 18.7114 21.5603C20.6524 20.497 20.4688 17.224 23.1832 18.3318C24.5887 18.9041 25.9498 19.7299 27.2915 20.453C29.366 21.5685 29.2693 22.7246 28.4786 25.1258C29.0702 23.3317 27.887 26.92 28.4786 25.1258Z",
    fill: "#E0B959"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_988_339"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 29,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactIcon);
export default __webpack_public_path__ + "static/media/ContactIcon.bf26e335a776a006b1af955835ba593e.svg";
export { ForwardRef as ReactComponent };